import styles from "./ClientRow.module.css";
import Button from "../utilities/button/Button";
import { MdDeleteForever } from "react-icons/md";
import { Link } from "react-router-dom";

function ClientRow({
  companyName,
  country,
  email,
  instagramId,
  facebookId,
  linkedinId,
  createdBy,
  clientId,
  OverlapHandler,
}) {
  return (
    <>
      <tr>
        <td className={styles.clientTd}>{companyName}</td>
        <td className={styles.clientTd}>{country}</td>
        <td className={styles.clientTd}>{email}</td>
        <td className={styles.clientTd}>{instagramId}</td>
        <td className={styles.clientTd}>{facebookId}</td>
        <td className={styles.clientTd}>{linkedinId}</td>
        <td className={styles.clientTd}>{createdBy}</td>
        <td className={styles.clientTd}>
          <Button>
            <Link
              style={{ color: "white", textDecoration: "none" }}
              to={`/viewpotentialclient/${clientId}`}
            >
              View
            </Link>
          </Button>
        </td>
        <td className={styles.clientTd}>
          <MdDeleteForever
            onClick={() => OverlapHandler(clientId)}
            style={{ color: "red", fontSize: "25px" }}
          ></MdDeleteForever>
        </td>
      </tr>
    </>
  );
}

export default ClientRow;
